import React, { useEffect, useMemo, useState } from "react";
import CustomFileUploader from "../../components/common/CustomFileUploader";
import {
  Box,
  Paper,
  Typography,
  TextField,
  InputAdornment,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Button as MUIButton,
  Tooltip as MUITooltip,
  Avatar,
} from "@mui/material";
import { FiSearch, FiEdit2, FiTrash2, FiPlus, FiMapPin } from "react-icons/fi";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import { Formik } from "formik";
import * as Yup from "yup";

import "./Branches.css";
import apis from "../../utils/apis";
import httpAction from "../../utils/httpAction";
import toast from "react-hot-toast";

const schema = Yup.object({
  name: Yup.string().min(2).required("Branch name is required"),
  mobile: Yup.string().required("Mobile is required"),
  address: Yup.string().required("Address is required"),
  mapUrl: Yup.string().url("Invalid map Link").required("Map Link required"),
  imageUrl: Yup.string().required("Image URL required"),
});

export default function Branches() {
  const [rows, setRows] = useState([]);

  const [q, setQ] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [url, setUrl] = useState([]);
  const filtered = useMemo(() => {
    const needle = q.toLowerCase();
    return rows.filter(
      (r) =>
        r.name.toLowerCase().includes(needle) ||
        r.address.toLowerCase().includes(needle) ||
        r.mobile.includes(needle)
    );
  }, [rows, q]);

  const openAdd = () => {
    setEditing(null);
    setShowModal(true);
  };

  const openEdit = (row) => {
    setEditing(row);
    setShowModal(true);
    setUrl([{ url: row?.imageUrl }]);
  };

  const removeRow = async (id) => {
    const data = {
      url: apis().deleteBranch + "?id=" + id,
      method: "DELETE",
    };

    const result = await httpAction(data);
    if (result?.status) {
      toast.success(result?.message);
      setRows((prev) => prev.filter((r) => r._id !== id));
    }
  };

  const saveBranch = async (values) => {
    const data = {
      url: editing?.name
        ? apis().updateBranch + "?id=" + editing?._id
        : apis().addBranch,
      method: editing?.name ? "PUT" : "POST",
      body: values,
    };
    const result = await httpAction(data);
    if (result?.status) {
      toast.success(result?.message);

      if (editing) {
        const findedIndex = rows.findIndex(
          (item) => item?._id === editing?._id
        );
        const branchedCopy = [...rows];
        branchedCopy.splice(findedIndex, 1, result?.branch);
        setRows(branchedCopy);
      } else {
        setRows((pev) => [...pev, result?.branch]);
      }
    }
    setShowModal(false);
    setEditing(null);
    setUrl([]);
  };

  const getBrnachList = async () => {
    const data = {
      url: apis().branchList,
    };
    const result = await httpAction(data);
    if (result?.status) {
      setRows(result?.list);
    }
  };





  
  useEffect(() => {
    getBrnachList();
  }, []);

  return (
    <Box className="branchesPage">
      <Box className="branchesHeader">
        <Typography className="branchesTitle">Branches</Typography>

        <MUIButton
          variant="contained"
          startIcon={<FiPlus />}
          className="branchesAddBtn"
          onClick={openAdd}
        >
          Add Branch
        </MUIButton>
      </Box>

      <Paper className="branchesCard" elevation={0}>
        <Box className="branchesToolbar">
          <TextField
            size="small"
            placeholder="Search branches..."
            value={q}
            onChange={(e) => setQ(e.target.value)}
            className="branchesSearch"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FiSearch />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box className="branchesTableWrap">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className="th">ID</TableCell>
                <TableCell className="th">Branch</TableCell>
                <TableCell className="th">Address</TableCell>
                <TableCell className="th">Mobile</TableCell>
                <TableCell className="th">Map</TableCell>
                <TableCell className="th" align="right">
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filtered.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} className="emptyRow">
                    No branches found
                  </TableCell>
                </TableRow>
              ) : (
                filtered.map((r, index) => (
                  <TableRow key={r.id} hover>
                    <TableCell className="idCell">{index + 1}</TableCell>

                    <TableCell>
                      <Box className="branchCell">
                        <Avatar
                          src={apis().localUrl + r.imageUrl}
                          className="branchAvatar"
                        />
                        <Typography className="branchName">{r.name}</Typography>
                      </Box>
                    </TableCell>

                    <TableCell className="addressCell">{r.address}</TableCell>

                    <TableCell className="mono">{r.mobile}</TableCell>

                    <TableCell>
                      <a
                        href={r.mapLink}
                        target="_blank"
                        rel="noreferrer"
                        className="mapLink"
                      >
                        <FiMapPin /> View
                      </a>
                    </TableCell>

                    <TableCell align="right">
                      <MUITooltip title="Edit">
                        <IconButton
                          size="small"
                          className="iconBtn"
                          onClick={() => openEdit(r)}
                        >
                          <FiEdit2 />
                        </IconButton>
                      </MUITooltip>

                      <MUITooltip title="Delete">
                        <IconButton
                          size="small"
                          className="iconBtn danger"
                          onClick={() => removeRow(r._id)}
                        >
                          <FiTrash2 />
                        </IconButton>
                      </MUITooltip>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </Box>
      </Paper>

      {/* Modal */}
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setEditing({});
          setUrl([]);
        }}
        centered
      >
        <Formik
          enableReinitialize
          initialValues={{
            name: editing?.name || "",
            imageUrl: editing?.imageUrl || "",
            address: editing?.address || "",
            mobile: editing?.mobile || "",
            mapUrl: editing?.mapLink || "",
          }}
          validationSchema={schema}
          onSubmit={(values) => saveBranch(values)}
        >
          {(formik) => (
            <form onSubmit={formik.handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>
                  {editing ? "Edit Branch" : "Add Branch"}
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="modalGrid">
                <div className="modalField modalField--full">
                  <CustomFileUploader
                    onEdit={url}
                    multiple={false}
                    onChange={(file) => {
                      const url = file[0];
                      formik.setFieldValue("imageUrl", url?.url);
                    }}
                  />

                  {formik.touched.imageUrl && formik.errors.imageUrl ? (
                    <div className="invalid-feedback d-block">
                      {formik.errors.imageUrl}
                    </div>
                  ) : null}
                </div>

                {["name", "address", "mobile", "mapUrl"].map((field) => (
                  <div key={field} className="modalField">
                    <label className="modalLabel">
                      {field.replace(/Url/, " Link")}
                    </label>
                    <input
                      type="text"
                      className={`form-control ${
                        formik.touched[field] && formik.errors[field]
                          ? "is-invalid"
                          : ""
                      }`}
                      {...formik.getFieldProps(field)}
                    />
                    {formik.touched[field] && formik.errors[field] ? (
                      <div className="invalid-feedback">
                        {formik.errors[field]}
                      </div>
                    ) : null}
                  </div>
                ))}
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button variant="primary" type="submit">
                  Save
                </Button>
              </Modal.Footer>
            </form>
          )}
        </Formik>
      </Modal>
    </Box>
  );
}
